// Convenience file to export proper types for some of our Store hooks, etc
// This was necessary to interact with the store properly in TypeScript
// See: https://redux.js.org/usage/usage-with-typescript/#define-typed-hooks

import { useSelector, useDispatch, TypedUseSelectorHook } from 'react-redux';

import Store from '@wetransfer/transfer/store';
import { InitialState } from '@wetransfer/transfer/store/types';

export type { InitialState } from '@wetransfer/transfer/store/types';

export type AppDispatch = typeof Store.dispatch;

interface DispatchFunction {
  (): AppDispatch;
}

export const useAppDispatch: DispatchFunction = useDispatch;

export const useAppSelector: TypedUseSelectorHook<InitialState> = useSelector;

export default {
  // useAppDispatch and useAppSelector are typed to return the proper types,
  // and should be used in place of useDispatch and useSelector
  useAppDispatch,
  useAppSelector,
};
